<template>
  <div>
 
 
 <!-- start company info header -->

  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>

  <!-- end company info header -->
  

  
  <div  id="pdfDocumentDownloadLink" style="text-align:center;margin-bottom:50px;font-weight:bold"></div>
  <div  id="pdfDocument"></div>

	
	
	
	
	  <card style="margin-top:50px;">
  
  
		  <div class="row" style="padding:20px 0px;">
			  <label class="col-sm-2 col-form-label">Document Name</label>
			  <div class="col-sm-7">
				<fg-input type="text"
						  name="document_name"
						  v-model="doc.document_name">
					</fg-input>
			  </div>
			</div>
			
			
			<!-- <div v-if="doc.is_main!=1" class="row" style="padding:20px 0px;">
			  <label class="col-sm-2 col-form-label">Privacy</label>
			  <div class="col-sm-7">
				 <fg-input>
                  <el-select
                  			class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="doc.private">
                    <el-option v-for="option in selects.private"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
			  </div>
			</div>-->
			
			
			
			 <div class="row">
      <label class="col-sm-2 col-form-label">Folder</label>
      <div class="col-sm-7">
        <fg-input>
                  
                  
                    <el-select class="select-primary"
                             size="large"
                             placeholder="Select Folder"
                             v-model="folder_id">
                    <el-option v-for="option in folders"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
        </fg-input>
        
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
  		  <div class="row" style="padding:20px 0px;">
			  <label class="col-sm-2 col-form-label">Remarks</label>
			  <div class="col-sm-7">
				<fg-input type="text"
						  name="notes"
						  v-model="doc.notes">
					</fg-input>
			  </div>
			</div>
			
			
			
			  <div class="row" style="padding:20px 0px;">
			  <label class="col-sm-2 col-form-label">Tags</label>
			  <div class="col-sm-7">
					<div v-for="tag in tags" >
          	
					<p-checkbox style="margin-bottom:15px;margin-top:15px;" :id="tag.id" :value="tag.id" 
					 v-model="selectedTags['t'+tag.id]">
	
						<span  style="color:#000">{{tag.tag_name}}</span>
						</p-checkbox>
				  </div>
				
				
			  </div><!-- end right col -->
			</div>
			
			
			
			
			
			
			
			
			<div style="text-align:right;">
				 
				<!--    <p-button   @click="viewDocuSigning()" type="success">E-Signing</p-button> -->
				 <p-button v-if="task_id" type="warning" @click="gotoTask()">View Task</p-button>

			</div>
  	  </card>
	<div>
	
	
	
	<h4 style="font-weight:bold;">Actions</h4>
	<card>
		<div style="text-align:left;">
			 <p-button type="info" @click.prevent="editDoc">Update Document</p-button>
		</div>
		
		 <p-button v-if="!doc.signing_status && is_key==0" type="danger"  @click="deleteDoc()" >
                <i slot="label" class="nc-icon nc-simple-remove"></i>
                Delete Document
     </p-button>
     <div v-else>
     	<div>
     		<strong v-if="is_key==0">* Document can't be deleted after being sent for signing. </strong>
     		<strong v-else>* Please delete key documents from the "Key Documents" tab. </strong>
     	</div>
     </div>
     
	
	</card>
	
	
	
	
	
	
	
     
	</div>    
	
	
	<div style="margin-bottom:150px;"></div>
	
  </div>
</template>
<script>
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  export default {
    components: {

    },
    
     mounted() {
     
			let uri = this.$base_url+'/api/v1/documents/'+ this.$route.params.did+"/"+this.$route.params.type;
			 ApiService.get(uri).then(response => {
				this.createForm = false
				this.coy = response.data.entity;
				let file = response.data.document;
				this.doc = response.data.doc_obj;
				this.is_key = response.data.is_key;
				this.task_id= response.data.task_id;
				
				this.folders = response.data.folders;
				
				this.folder_id = response.data.folder_id;
				
				let vm = this;
				
				//for tags
				this.tags = response.data.tags;
		
				response.data.tags.forEach(function(tag){
						if(tag){
								vm.selectedTags["t"+tag.id] = false;
						 }
				 });
				 
				 
				 //process tagged					
				 response.data.tagged.forEach(function(tag){								
						vm.selectedTags["t"+tag.document_tag_id] = true;
			
				});
						
				
		
				if(this.doc.format=="pdf"){
					let b64 = file;
				
					// Embed the PDF into the HTML page and show it to the user
					var obj = document.createElement('object');
					obj.style.width = '100%';
					obj.style.height = '842pt';
					obj.title = this.doc.document_name;
					obj.type = 'application/pdf';
					obj.data = 'data:application/pdf;base64,' + b64;
					document.getElementById("pdfDocument").appendChild(obj);
					
					// Insert a link that allows the user to download the PDF file
					var link = document.createElement('a');
					link.innerHTML = 'Download PDF file';
					link.download = this.doc.document_name+'.pdf';
					link.href = 'data:application/octet-stream;base64,' + b64;
					document.getElementById("pdfDocumentDownloadLink").appendChild(link);
				}
				else if(this.doc.format=="jpeg" || this.doc.format=="jpg" || this.doc.format=="png"){
					let b64 = file;
				
					var obj = document.createElement('object');
					obj.style.width = '100%';
					obj.style.height = '842pt';
					obj.type = 'application/'+this.doc.format;
					obj.src = 'data:image/jpeg;base64,,' + b64;
					
					
					var img = document.createElement("img");
					img.src = 'data:image/'+this.doc.format+';base64,'+b64
					document.getElementById("pdfDocument").append(img);
					
					
					
					// Insert a link that allows the user to download the PDF file
					var link = document.createElement('a');
					link.innerHTML = 'Download file';
					link.download = this.coy.uen+'_document.'+this.doc.format;
					link.href = 'data:application/octet-stream;base64,' + b64;
					document.getElementById("pdfDocumentDownloadLink").appendChild(link);
				}
				
			
			})//end resposne
      	
      	
      	
      
    },
    
     
    data () {
      return {
    	doc:{
    		format: 'pdf',
    		
    	},
    	tid:0,
    	is_key:0,
    	task_id:0,
    	folder_id:0,
    	folders:[],
    	tags:[],
    	selectedTags:[],
    	selectedTagsArr:[],
    	coy:[],
    	selects: {
          t_status: [
            {value: 1, label: 'Pending'},
            {value: 2, label: 'Waiting For Signature'},
            {value: 3, label: 'Signed'},
		   ],
		  private: [
            {value: 1, label: 'Private'},
            {value: 0, label: 'Visible To Client'},

		   ],
		 }

      }
    },
    computed: {
  			
     
    },
    methods:{
    	viewDocuSigning(did){
     		this.$router.push( '/document-signing/'+this.doc.task_id+'/entity/'+ this.doc.entity_id+"/task/"+this.$route.params.did)
    	 },
    	editDoc(){
    		let uri = this.$base_url+'/api/v1/documents/edit';
    		
    		
    		//get tags:
       		const vm = this;
       		vm.selectedTagsArr = [];
			
			var tags_1 = this.tags;
			tags_1.forEach(function(t){
				if(vm.selectedTags["t"+t.id]==true){
					vm.selectedTagsArr.push(t.id);
				}
			});
			
      		ApiService.post(uri, {
      			'doc': this.doc,
      			'folder_id': this.folder_id,
      			'tags': vm.selectedTagsArr,
      		
      		}).then(response => {
      			//vm.$router.push( '/view-entity/'+ this.doc.entity_id)
      			 vm.$router.push( '/entity-documents/'+ this.doc.entity_id) 
      		
      		})
    	},
    	gotoTask(){
      		this.$router.push( '/edit-task/'+this.task_id+'/entity/'+this.coy.id)
      	},
    	deleteDoc(){
    		
			 
			 const vm = this;
			 swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
          	}).then(function () {
             	let uri = vm.$base_url+'/api/v1/documents/delete/'+ vm.$route.params.did;
				 ApiService.post(uri).then(response => {
					vm.$router.push( '/view-entity/'+vm.coy.id)
				 })
         
            
          })// end swal
    	
    	},
     	goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
      
      
    },

    
  }
</script>
<style>
  
</style>


